const div = document.getElementById('calmac-interactive-map');
const title = div?.getAttribute('data-title');
const text = div?.getAttribute('data-text');

const interactiveMapConfig = {
  title: title ? decodeURI(title) : '',
  text: text ? decodeURI(text) : '',
};

export default interactiveMapConfig;
